module.exports = {
  "locations": [
    {
      "ID": 1,
      "Name": "Advancing Sickle Cell Advocacy Project, Inc. (ASAP)",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 26.0178946,
      "Longitude": -80.20349379999999,
      "Address": "PO Box 813215",
      "City": "Hollywood",
      "State": "FL",
      "Zip": "33081",
      "Telephone": "(954) 951-1108",
      "Email": "info@asapbeinformed.org",
      "Website": "http://www.asapbeinformed.org",
      "LogoImage": "logos-assets/5.png"
    },
    {
      "ID": 2,
      "Name": "Bridges Pointe Inc. Sickle Cell Agency",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.001505,
      "Longitude": -78.8949526,
      "Address": "800 N. Mangum Street Suite 104",
      "City": "Durham",
      "State": "NC",
      "Zip": "27701",
      "Telephone": "(919) 323-8443",
      "Email": "bridgespointenc@gmail.com",
      "Website": "http://www.bridgespointenc.org",
      "LogoImage": "logos-assets/6.png"
    },
    {
      "ID": 3,
      "Name": "Bridging the Gap Adult Sickle Cell Disease Foundation of Nevada",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.2375311,
      "Longitude": -115.0735431,
      "Address": "4260 Studio St.",
      "City": "Las Vegas",
      "State": "NV",
      "Zip": "89115",
      "Telephone": "(702) 945-1174",
      "Email": "ascdofnv@gmail.com",
      "Website": "https://www.ascdfofnv.org",
      "LogoImage": "logos-assets/7.png"
    },
    {
      "ID": 4,
      "Name": "Cayenne Wellness / Sickle Cell Disease Education, Support and Advocacy",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 34.17658249999999,
      "Longitude": -118.3110577,
      "Address": "205 S. Flower Street",
      "City": "Burbank",
      "State": "CA",
      "Zip": "91502",
      "Telephone": "(818) 940-0079",
      "Email": "info@cayennewellness.org",
      "Website": "https://www.cayennewellness.org",
      "LogoImage": "logos-assets/8.png"
    },
    {
      "ID": 5,
      "Name": "Dreamsickle Kids Foundation, SCDAA Nevada Chapter",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.1169204,
      "Longitude": -115.1184777,
      "Address": "4006 S. Eastern Ave. Suite 204",
      "City": "Las Vegas",
      "State": "NV",
      "Zip": "89119",
      "Telephone": "(702) 723-2286",
      "Email": "info@dreamsicklekids.org",
      "Website": "https://www.dreamsicklekids.org",
      "LogoImage": "logos-assets/9.png"
    },
    {
      "ID": 6,
      "Name": "Martin Center Sickle Cell Initiative, Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.8208719,
      "Longitude": -86.14470899999999,
      "Address": "3549 N. College Ave.",
      "City": "Indianapolis",
      "State": "IN",
      "Zip": "46205",
      "Telephone": "(317) 927-5158",
      "Email": "information@themartincenter.org",
      "Website": "http://www.themartincenter.org",
      "LogoImage": "logos-assets/10.png"
    },
    {
      "ID": 7,
      "Name": "Northeast Louisiana Sickle Cell Anemia Foundation",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 32.483838,
      "Longitude": -92.08662299999999,
      "Address": "1604 Winnsboro Road",
      "City": "Monroe",
      "State": "LA",
      "Zip": "71202",
      "Telephone": "(318) 322-0896",
      "Email": "nelasickle@att.net",
      "Website": "https://www.nelascaf.org",
      "LogoImage": "logos-assets/11.png"
    },
    {
      "ID": 8,
      "Name": "Sickle Cell Association of Kentuckiana",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 38.2534281,
      "Longitude": -85.7500811,
      "Address": "201 E. Jefferson Street",
      "City": "Louisville",
      "State": "KY",
      "Zip": "40202",
      "Telephone": "(502) 569-2070",
      "Email": "thescak@yahoo.com",
      "Website": "http://www.thescakorg.wixsite.com/thescakorg",
      "LogoImage": "logos-assets/12.png"
    },
    {
      "ID": 9,
      "Name": "Sickle Cell Association of Texas Marc Thomas Foundation - Dallas",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 32.861195,
      "Longitude": -96.8854514,
      "Address": "2351 W. Northwest Hwy. Ste. 1233",
      "City": "Dallas",
      "State": "TX",
      "Zip": "75220",
      "Telephone": "(469) 914-0909",
      "Email": "info@sicklecelltx.org",
      "Website": "https://www.sicklecelltx.org",
      "LogoImage": "logos-assets/13.png"
    },
    {
      "ID": 10,
      "Name": "Sickle Cell Community Advisory Council of Northern California",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 37.6687665,
      "Longitude": -122.0809964,
      "Address": "P.O Box 56152",
      "City": "Hayward",
      "State": "CA",
      "Zip": "94545",
      "Telephone": "N/A",
      "Email": "sccacnorcal@gmail.com",
      "Website": "https://www.onescdvoice.com/place/sickle-cell-community-advisory-council-northern-california/",
      "LogoImage": "logos-assets/14.png"
    },
    {
      "ID": 11,
      "Name": "Sickled Not Broken Foundation of Nevada",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.266797,
      "Longitude": -115.1154953,
      "Address": "5892 Losee Rd Ste #132-220",
      "City": "Las Vegas",
      "State": "NV",
      "Zip": "89081",
      "Telephone": "(702) 417-3175",
      "Email": "Info@sicklednotbroken.org",
      "Website": "https://www.sicklednotbroken.org",
      "LogoImage": "logos-assets/15.png"
    },
    {
      "ID": 12,
      "Name": "Supporters of Families with Sickle Cell Disease",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.2320783,
      "Longitude": -95.97904419999999,
      "Address": "5424 N. Madison Ave. Ste. 9",
      "City": "Tulsa",
      "State": "OK",
      "Zip": "74126",
      "Telephone": "(918) 619-6174",
      "Email": "swithsicklecell@att.net",
      "Website": "https://www.sicklecelloklahoma.org",
      "LogoImage": "logos-assets/16.png"
    },
    {
      "ID": 13,
      "Name": "The Sickle Cell Association of New Jersey, Inc. - Newark",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 40.7281591,
      "Longitude": -74.1758321,
      "Address": "1016 Broad Street",
      "City": "Newark",
      "State": "NJ",
      "Zip": "07102",
      "Telephone": "(973) 482-9070",
      "Email": "sicklecellanj@gmail.com",
      "Website": "https://www.sicklecellnewjersey.org",
      "LogoImage": "logos-assets/17.png"
    },
    {
      "ID": 14,
      "Name": "TOVA Community Health",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.7514274,
      "Longitude": -75.5813866,
      "Address": "213 Greenhill Ave. Suite B",
      "City": "Wilmington",
      "State": "DE",
      "Zip": "19805",
      "Telephone": "(302) 429-5870 EXT. 120",
      "Email": "contact@tovacommunityhealth.org",
      "Website": "https://www.tovacommunityhealth.org",
      "LogoImage": "logos-assets/18.png"
    },
    {
      "ID": 15,
      "Name": "Uriel E. Owens Sickle Cell Disease Association of the Midwest",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.1159298,
      "Longitude": -94.6207443,
      "Address": "444 Minnesota Ave. Ste 300",
      "City": "Kansas City",
      "State": "KS",
      "Zip": "66101",
      "Telephone": "(913) 735-2622",
      "Email": "info@sicklecellmidwest.org",
      "Website": "https://www.sicklecellmidwest.org",
      "LogoImage": "logos-assets/19.png"
    },
    {
      "ID": 16,
      "Name": "William E. Proudford Sickle Cell Fund Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.2903848,
      "Longitude": -76.6121893,
      "Address": "PO Box 42411",
      "City": "Baltimore",
      "State": "MD",
      "Zip": "21284",
      "Telephone": "(888) 893-6735",
      "Email": "N/A",
      "Website": "http://www.wepsicklecell.org",
      "LogoImage": "logos-assets/20.png"
    },
    {
      "ID": 17,
      "Name": "Crescent Foundation ",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 40.0454765,
      "Longitude": -75.1911288,
      "Address": "6635 McCallum St., Apt A704",
      "City": "Philadelphia",
      "State": "PA",
      "Zip": "19119",
      "Telephone": "(302) 530-4864",
      "Email": "info@crescentfoundationscd.org",
      "Website": "https://www.crescentfoundationscd.org/",
      "LogoImage": "logos-assets/21.png"
    },
    {
      "ID": 18,
      "Name": "Maryland Sickle Cell Disease Association, Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.2268333,
      "Longitude": -76.8180315,
      "Address": "8775 Centre Park Dr., Ste 701",
      "City": "Columbia",
      "State": "MD",
      "Zip": "21045",
      "Telephone": "(410) 465-4822",
      "Email": "mscdainfo@verizon.net",
      "Website": "https://marylandsicklecelldisease.org/",
      "LogoImage": "logos-assets/22.png"
    },
    {
      "ID": 19,
      "Name": "Sickle Cell Disease Association of America Southern CT",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 41.3109323,
      "Longitude": -72.9415533,
      "Address": "1389 Chapel St.",
      "City": "New Haven",
      "State": "CT",
      "Zip": "06511",
      "Telephone": "(203) 859-5355",
      "Email": "info.scdaasc@gmail.com",
      "Website": "https://www.michelleshousect.org/",
      "LogoImage": "logos-assets/23.png"
    },
    {
      "ID": 20,
      "Name": "Sick Cells",
      "Type": "National",
      "StateWide": false,
      "Latitude": 38.9032398,
      "Longitude": -77.03220329999999,
      "Address": "1012 14th St., Ste. 500",
      "City": "Washington",
      "State": "DC",
      "Zip": "20005",
      "Telephone": "N/A",
      "Email": "info@sickcells.org",
      "Website": "https://sickcells.org/",
      "LogoImage": "logos-assets/24.png"
    },
    {
      "ID": 21,
      "Name": "Sickle Cell Anemia Foundation of Oregon, Inc",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 45.5562778,
      "Longitude": -122.5734208,
      "Address": "4566 NE 87th Ave.",
      "City": "Portland",
      "State": "OR",
      "Zip": "97220",
      "Telephone": "(503) 249-1366",
      "Email": "info@sicklecelloregon.org",
      "Website": "https://sicklecelloregon.org/",
      "LogoImage": "logos-assets/25.png"
    },
    {
      "ID": 22,
      "Name": "Sickle Cell Association of Texas Marc Thomas Foundation - Austin",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 30.329118,
      "Longitude": -97.71145399999999,
      "Address": "314 E. Highland Mall Blvd., Ste. 411",
      "City": "Austin",
      "State": "TX",
      "Zip": "78752",
      "Telephone": "(512) 458-9767",
      "Email": "info@sicklecelltx.org",
      "Website": "https://www.sicklecelltx.org/",
      "LogoImage": "logos-assets/13.png"
    },
    {
      "ID": 23,
      "Name": "Sickle Cell Association of Texas Marc Thomas Foundation - Houston",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 29.8080109,
      "Longitude": -95.4368903,
      "Address": "2500 E.T.C. Jester Blvd., Ste.178",
      "City": "Houston",
      "State": "TX",
      "Zip": "77008",
      "Telephone": "(713) 534-1712",
      "Email": "info@sicklecelltx.org",
      "Website": "https://www.sicklecelltx.org/",
      "LogoImage": "logos-assets/13.png"
    },
    {
      "ID": 24,
      "Name": "Sickle Cell Association of Texas Marc Thomas Foundation - San Antonio",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 29.5187988,
      "Longitude": -98.4535343,
      "Address": "8626 Tesoro Dr., Ste. 205J",
      "City": "San Antonio",
      "State": "TX",
      "Zip": "78217",
      "Telephone": "(210) 899-3928",
      "Email": "info@sicklecelltx.org",
      "Website": "https://www.sicklecelltx.org/",
      "LogoImage": "logos-assets/13.png"
    },
    {
      "ID": 25,
      "Name": "Sickle Cell Disease Association of America",
      "Type": "National",
      "StateWide": false,
      "Latitude": 39.1752003,
      "Longitude": -76.7341031,
      "Address": "7240 Parkway Drive, Suite 180",
      "City": "Hanover",
      "State": "MD",
      "Zip": "21076",
      "Telephone": "(800) 421-8453",
      "Email": "info@sicklecelldisease.org",
      "Website": "https://www.sicklecelldisease.org/support-and-community/find-member-organizations/",
      "LogoImage": "logos-assets/29.png"
    },
    {
      "ID": 26,
      "Name": "Candices Sickle Cell Fund ",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 40.86701540000001,
      "Longitude": -73.86749549999999,
      "Address": "PO BOX 672237",
      "City": "Bronx",
      "State": "NY",
      "Zip": "10467",
      "Telephone": "(646) 436-0477",
      "Email": "thevoiceofawarrior.cscf@gmail.com",
      "Website": "https://www.candicessicklecellfund.org/",
      "LogoImage": "logos-assets/30.png"
    },
    {
      "ID": 27,
      "Name": "The Children's Sickle Cell Foundation, Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 40.4222026,
      "Longitude": -80.0092372,
      "Address": "Gove Business Center, 226 Paul Street",
      "City": "Pittsburgh",
      "State": "PA",
      "Zip": "15211",
      "Telephone": "(412) 488-2723",
      "Email": "support@cscfkids.org",
      "Website": "http://www.cscfkids.org/",
      "LogoImage": "logos-assets/31.png"
    },
    {
      "ID": 28,
      "Name": "Kincaid's Kindred Spirits Inc., Citizens for Healthy Living Sickle Cell Anemia Adult Community Outreach Support & Youth Mentoring Group",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 41.4908682,
      "Longitude": -81.67274990000001,
      "Address": "PO Box 93142",
      "City": "Cleveland",
      "State": "OH",
      "Zip": "44101",
      "Telephone": "(216) 347-1931",
      "Email": "kks4scd@gmail.com",
      "Website": "https://www.kks4scd.org/",
      "LogoImage": "logos-assets/32.png"
    },
    {
      "ID": 29,
      "Name": "Mississippi Sickle Cell Foundation",
      "Type": "Regional",
      "StateWide": true,
      "Latitude": 32.3293793,
      "Longitude": -90.1948719,
      "Address": "350 W. Woodrow Wilson Ave. Ste. 731-B",
      "City": "Jackson",
      "State": "MS",
      "Zip": "39213",
      "Telephone": "(601) 366-5874",
      "Email": "mssicklecellfnd@yahoo.com",
      "Website": "http://www.mssicklecellfoundation.org/",
      "LogoImage": "logos-assets/33.png"
    },
    {
      "ID": 30,
      "Name": "North Alabama Sickle Cell Foundation, Inc",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 34.7320114,
      "Longitude": -86.5889835,
      "Address": "224 Church St. Ste B",
      "City": "Huntsville",
      "State": "AL",
      "Zip": "35801",
      "Telephone": "(256) 536-2723",
      "Email": "pthompson@sicklecellna.org",
      "Website": "http://sicklecellna.org/",
      "LogoImage": "logos-assets/34.png"
    },
    {
      "ID": 31,
      "Name": "Sickle Cell 101",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 37.724119,
      "Longitude": -122.458616,
      "Address": "N/A",
      "City": "San Francisco",
      "State": "CA",
      "Zip": "94112",
      "Telephone": "(513) 813-7223",
      "Email": "info@sc101.org",
      "Website": "https://www.sc101.org/",
      "LogoImage": "logos-assets/35.png"
    },
    {
      "ID": 32,
      "Name": "Sickle Cell Foundation of Minnesota",
      "Type": "Regional",
      "StateWide": true,
      "Latitude": 45.0167268,
      "Longitude": -93.3364004,
      "Address": "PO Box 22306 ",
      "City": "Minneapolis",
      "State": "MN",
      "Zip": "55422",
      "Telephone": "(763) 607-5555",
      "Email": "N/A",
      "Website": "https://www.sicklecellmn.org/",
      "LogoImage": "logos-assets/36.png"
    },
    {
      "ID": 33,
      "Name": "Sickle Cell Alliance Foundation",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.2048792,
      "Longitude": -84.5828404,
      "Address": "6225 Colerain Ave. Ste. B",
      "City": "Cincinnati",
      "State": "OH",
      "Zip": "45239",
      "Telephone": "(513) 813-7223",
      "Email": "scafcincinnati@gmail.com",
      "Website": "http://www.scafcincy.com/",
      "LogoImage": "logos-assets/37.png"
    },
    {
      "ID": 34,
      "Name": "Sickle Cell Disease Association of Illinois - Chicago",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 41.7461354,
      "Longitude": -87.683172,
      "Address": "8108 S. Western Ave",
      "City": "Chicago",
      "State": "IL",
      "Zip": "60620",
      "Telephone": "(773) 526-5016",
      "Email": "sicklecelldisease-illinois@scdai.org",
      "Website": "https://www.sicklecelldisease-illinois.org/",
      "LogoImage": "logos-assets/38.png"
    },
    {
      "ID": 35,
      "Name": "Sickle Cell Disease Foundation ",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 34.07033550000001,
      "Longitude": -117.5731183,
      "Address": "3602 Inland Empire Blvd.",
      "City": "Ontario",
      "State": "CA",
      "Zip": "91764",
      "Telephone": "(877) 288-2873",
      "Email": "info@scdfc.org",
      "Website": "https://www.scdfc.org/",
      "LogoImage": "logos-assets/39.png"
    },
    {
      "ID": 36,
      "Name": "Sickle Cell Foundation, Incorporated. - Tallahassee",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 30.4870262,
      "Longitude": -84.3126162,
      "Address": "1336 Vickers Rd.",
      "City": "Tallahassee",
      "State": "FL",
      "Zip": "32303",
      "Telephone": "(850) 222-2355",
      "Email": "info@sicklecellfoundation.org",
      "Website": "http://sicklecellfoundation.org/",
      "LogoImage": "logos-assets/40.png"
    },
    {
      "ID": 37,
      "Name": "Sickle Cell Association of South Louisiana",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 30.4480981,
      "Longitude": -91.1640907,
      "Address": "2301 North Blvd.",
      "City": "Baton Rouge",
      "State": "LA",
      "Zip": "70806",
      "Telephone": "(225) 346-8434",
      "Email": "info@scasl.org",
      "Website": "http://scasl.org/",
      "LogoImage": "logos-assets/41.png"
    },
    {
      "ID": 38,
      "Name": "Sickle Cell Community Consortium (SCCC)",
      "Type": "National",
      "StateWide": false,
      "Latitude": 33.7552529,
      "Longitude": -84.38307549999999,
      "Address": "135 Auburn Avenue",
      "City": "Atlanta",
      "State": "GA",
      "Zip": "30303",
      "Telephone": "(706) 619-6029",
      "Email": "info@sicklecellconsortium.org",
      "Website": "https://sicklecellconsortium.org/",
      "LogoImage": "logos-assets/42.png"
    },
    {
      "ID": 39,
      "Name": "Sickle Cell Association of Houston, Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 29.7721545,
      "Longitude": -95.3306341,
      "Address": "4014 Market Street",
      "City": "Houston",
      "State": "TX",
      "Zip": "77020",
      "Telephone": "(832) 252-9293",
      "Email": "care@sicklecellhouston.org",
      "Website": "https://www.sicklecellhouston.org/",
      "LogoImage": "logos-assets/43.png"
    },
    {
      "ID": 40,
      "Name": "The Foundation for Sickle Cell Disease Research",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 25.99581,
      "Longitude": -80.20562,
      "Address": "1685 South State Road 7, Unit 4",
      "City": "Hollywood",
      "State": "FL",
      "Zip": "33023",
      "Telephone": "(954) 397-3251",
      "Email": "info@fscdr.org",
      "Website": "https://www.fscdr.org/",
      "LogoImage": "logos-assets/44.png"
    },
    {
      "ID": 41,
      "Name": "Sickle Cell Warriors",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 32.718811,
      "Longitude": -117.162216,
      "Address": "N/A",
      "City": "San Diego",
      "State": "CA",
      "Zip": "92101",
      "Telephone": "(510) 470-0180",
      "Email": "contact@sicklecellwarriors.com",
      "Website": "https://www.sicklecellwarriors.com",
      "LogoImage": "logos-assets/45.png"
    },
    {
      "ID": 42,
      "Name": "Sickle Cell Awareness Foundation International",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 40.69722,
      "Longitude": -73.78929,
      "Address": "108-03 164th Pl.",
      "City": "Jamaica",
      "State": "NY",
      "Zip": "11433",
      "Telephone": "(718) 657-3173",
      "Email": "MerleneSotillo@Scafci.org",
      "Website": "https://www.scafcorpint.org/",
      "LogoImage": "logos-assets/46.png"
    },
    {
      "ID": 43,
      "Name": "Piedmont Health Services and Sickle Cell Agency - Greensboro",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 36.0711268,
      "Longitude": -79.7792356,
      "Address": "1102 E. Market Street",
      "City": "Greensboro",
      "State": "NC",
      "Zip": "27401",
      "Telephone": "(800) 733-8297",
      "Email": "info@piedmonthealthservices.org",
      "Website": "https://www.piedmonthealthservices.org/",
      "LogoImage": "logos-assets/47.png"
    },
    {
      "ID": 44,
      "Name": "Sickle Cell Disease Association of America, Philadelphia/Delaware Valley Chapter",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.9914384,
      "Longitude": -75.2335725,
      "Address": "5300 Wynnefield Avenue, 2nd Floor",
      "City": "Philadelphia",
      "State": "PA",
      "Zip": "19131",
      "Telephone": "(215) 471-8686",
      "Email": "Scdaa.pdvc@verizon.net",
      "Website": "http://www.sicklecelldisorder.com/",
      "LogoImage": "logos-assets/48.png"
    },
    {
      "ID": 45,
      "Name": "Ohio Sickle Cell & Health Association",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 39.9553439,
      "Longitude": -82.9990371,
      "Address": "341 South Third St., Suite 200",
      "City": "Columbus",
      "State": "OH",
      "Zip": "43215",
      "Telephone": "N/A",
      "Email": "OSCHA@aol.com",
      "Website": "http://ohiosicklecell.org/",
      "LogoImage": "logos-assets/49.png"
    },
    {
      "ID": 46,
      "Name": "Sickle Cell Foundation of Georgia, Inc.",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 33.7233038,
      "Longitude": -84.4680601,
      "Address": "2391 Benjamin E Mays Drive, SW",
      "City": "Atlanta",
      "State": "GA",
      "Zip": "30311",
      "Telephone": "(800) 326-5287",
      "Email": "info@sicklecellga.org",
      "Website": "https://sicklecellga.org/",
      "LogoImage": "logos-assets/50.png"
    },
    {
      "ID": 47,
      "Name": "Sickle Cell Anemia Awareness of San Francisco (SCAASF)",
      "Type": "Regional",
      "StateWide": false,
      "Latitude": 37.7398672,
      "Longitude": -122.3855623,
      "Address": "1307 Evans Ave",
      "City": "San Francisco",
      "State": "CA",
      "Zip": "94124",
      "Telephone": "(415) 720-4458",
      "Email": "crisis@scaasf.org",
      "Website": "https://www.scaasf.org/",
      "LogoImage": "logos-assets/51.png"
    }
  ]
}
;